import { Card } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

const ClusteringFormSkeleton = () => (
  <Card>
    <Card.Body>
      <div className="mb-2" style={{ width: 220 }}>
        <TextLoading height={12} />
      </div>
      <div className="d-block">
        <TextLoading height={220} />
      </div>
      <div
        className="d-flex flex-column mt-3"
        style={{ gap: 12 }}
      >
        <div>
          <div className="d-flex align-items-center justify-content-between gap-2">
            <div style={{ width: 160 }}>
              <TextLoading height={12} />
            </div>
            <div style={{ width: 140 }}>
              <TextLoading height={12} />
            </div>
          </div>
          <div className="mt-2 d-block">
            <TextLoading height={4} />
          </div>
        </div>
        <div className="d-flex gap-2">
          <div className="flex-grow-1">
            <TextLoading height={48} />
          </div>
          <div className="flex-grow-1">
            <TextLoading height={48} />
          </div>
        </div>
        <div className="d-block">
          <TextLoading height={38} />
        </div>
      </div>
    </Card.Body>
  </Card>
);

export default ClusteringFormSkeleton;
